export enum EBookerDatesSource {
	USER = 'user',
	AUTO = 'auto',
}

export const useBookerService = () => {
	const { businessNow } = useDateTimeService()

	const getStartDate = () => {
		const now = businessNow()
		const startDate = new Date(now)
		startDate.setHours(now.getHours() + 3, 0, 0, 0)

		if (now.getMinutes() <= 30) {
			startDate.setMinutes(30)
		} else {
			startDate.setHours(startDate.getHours() + 1, 0, 0, 0)
		}
		return startDate
	}

	const getEndDate = () => {
		const endDate = new Date(getStartDate())
		endDate.setDate(endDate.getDate() + 3)
		endDate.setHours(12, 0, 0, 0)
		return endDate
	}

	const useDefaultRentDays = () => useState('default-rent-days', () => getRentalDays(getStartDate(), getEndDate()))

	return { getStartDate, getEndDate, useDefaultRentDays }
}
